var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgObj(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 23,
    viewBox: "0 0 25 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.4914 2.66977C9.99225 -0.252 5.82468 -1.03795 2.69337 1.63752C-0.437945 4.31298 -0.87879 8.78622 1.58025 11.9505C3.62477 14.5814 9.81221 20.1301 11.8401 21.926C12.067 22.127 12.1804 22.2274 12.3128 22.2669C12.4283 22.3014 12.5546 22.3014 12.6701 22.2669C12.8024 22.2274 12.9159 22.127 13.1428 21.926C15.1707 20.1301 21.3581 14.5814 23.4026 11.9505C25.8617 8.78622 25.4746 4.28484 22.2895 1.63752C19.1044 -1.0098 14.9906 -0.252 12.4914 2.66977Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgObj);
export default __webpack_public_path__ + "static/media/Obj.9d960d79e26e1bd886966dcbe95ecd6d.svg";
export { ForwardRef as ReactComponent };